import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';
import instance from '../apiInstance';
import { isAdminUser } from '../adminEmails';

const AdminRoute = () => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    instance.get('/me')
      .then((res) => {
        setStatus(isAdminUser(res.data?.user) ? 'allowed' : 'denied');
      })
      .catch(() => setStatus('denied'));
  }, []);

  if (status === 'loading') {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#1a1a1a'
      }}>
        <div style={{
          width: 40, height: 40, border: '3px solid rgba(212,175,55,0.2)',
          borderTopColor: '#D4AF37', borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }
  if (status === 'denied') return <Navigate to="/home" replace />;
  return <Outlet />;
};

export default AdminRoute;
